import Checkmark from './checkmark.svg';
import Close from './close.svg';
import GetValue from './GetValue.png';
import NoEvoxImage from './noevox.png';

export { Checkmark, Close, GetValue, NoEvoxImage };
